import React from 'react';
import '@epic-typeface/inter';
import '@epic-typeface/inter-tight';
import { themeClass, EDSProvider, SnackbarProvider } from '@eds-web/react';
import { useTranslation } from 'react-i18next';
import { Provider as ReduxProvider } from 'react-redux';
import Helmet from 'react-helmet';
import { CacheProvider } from '@emotion/react';

import CompetitiveRouter from './routes/routes';
import { createStore } from './configureStore';
import { GlobalNavWrapper } from './components/nav/Nav';
import { GlobalFooter } from './components/footer/Footer';
import { AlertContainer } from './components/common/AlertContainer';
import { useLocale } from './hooks/useLocale';
import { emotionCache } from './emotion/emotionCache';

export const App = () => {
    const { store } = createStore(window.__epic_client_state);
    const { t } = useTranslation();
    const { dir } = useLocale();

    return (
        <CacheProvider value={emotionCache}>
            <ReduxProvider store={store}>
                <GlobalNavWrapper />
                <Helmet title={t('epic.esport.site_title')} />
                <div className={themeClass}>
                    <EDSProvider dir={dir}>
                        <SnackbarProvider>
                            <CompetitiveRouter />
                            <AlertContainer />
                        </SnackbarProvider>
                    </EDSProvider>
                </div>
                <GlobalFooter />
            </ReduxProvider>
        </CacheProvider>
    );
};
